import Vue from 'vue'
import Router from 'vue-router'
//避免导航冗余
const routerPush = Router.prototype.push
Router.prototype.push = function (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: 'login',
      component: resolve => (require(['@/components/login'], resolve)),
      meta: {
        active: "登录"
      }
    },
    {
      path: "/register",
      name: 'register',
      component: resolve => (require(['@/components/register'], resolve)),
      meta: {
        active: "注册"
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: resolve => (require(['@/components/agreement'], resolve)),
      meta: {
        active: "注册协议"
      }
    },
    {
      path: '/',
      name: 'index',
      component: resolve => (require(["@/components/index"], resolve)),
      redirect: "/home",
      children: [
        {
          path: "/home",
          name: "home",
          component: resolve => (require(['@/components/home'], resolve)),
          meta: {
            active: "首页"
          }
        },
        {
          path: "/introduce",
          name: 'introduce',
          component: resolve => (require(['@/components/introduce'], resolve)),
          meta: {
            active: '公司简介'
          }
        },
        {
          path: '/contact',
          name: "contact",
          component: resolve => (require(['@/components/contact'], resolve)),
          meta:{
            active:"联系我们"
          }
        },
        {
          path: "/orderadd",
          name: "orderadd",
          component: resolve => (require(['@/components/orderadd'], resolve)),
          meta: {
            active: "创建订单"
          }
        },
        {
          path: "/orderpay",
          name: 'orderpay',
          component: resolve => (require(['@/components/orderpay'], resolve)),
          meta: {
            active: "订单支付"
          }
        },
        {
          path: "/orderlist",
          name: "orderlist",
          component: resolve => (require(['@/components/orderlist'], resolve)),
          meta: {
            active: '订单列表'
          }
        },
        {
          path: "/orderinfo",
          name: "orderinfo",
          component: resolve => (require(['@/components/orderinfo'], resolve)),
          meta: {
            active: '订单列表'
          }
        },
        {
          path: "/personalcenter",
          name: 'personalcenter',
          component: resolve => (require(['@/components/personalcenter'], resolve)),
          meta: {
            active: "个人中心"
          }
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js